import styled, { css } from 'styled-components';
import InsightSectionContainer from 'components/InsightSectionContainer';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
`;

export const StyledInsightSectionContainer = styled(InsightSectionContainer)`    
    flex: 1;
    flex-direction: column;
    display: flex;
    align-items: stretch;
    justify-content: stretch;

    h2 {
        font-size: 1.625rem;
        font-style: normal;
        font-weight: 500;
        line-height: 2.25rem;
    }

    ${(props) => !props.isLoading && css`
        & > div:last-child {
            display: flex;
            flex: 1;
            align-self: stretch;
            height: fit-content;
            margin-left: -1.5rem;
            margin-right: -1.5rem;
        }
    `};
`;

export const Content = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 1.5rem 1.5rem 0 1.5rem;
`;
